/**
 * WSH Product Media Slides
 * Desktop: thumbnail click + arrow navigation
 * Mobile: CSS scroll-snap + dot indicator sync
 */
(function () {
  const container = document.querySelector('.wsh-slides');
  if (!container) return;

  const main = container.querySelector('.wsh-slides__main');
  const slides = Array.from(main.querySelectorAll('.wsh-slides__slide'));
  const thumbs = Array.from(container.querySelectorAll('.wsh-slides__thumb'));
  const dots = Array.from(container.querySelectorAll('.wsh-slides__dot'));
  const prevBtn = container.querySelector('.wsh-slides__arrow--prev');
  const nextBtn = container.querySelector('.wsh-slides__arrow--next');

  if (slides.length === 0) return;

  let currentIndex = 0;

  function isMobile() {
    return window.innerWidth < 750;
  }

  function goToSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;

    if (isMobile()) {
      const target = slides[index];
      if (target) {
        main.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    } else {
      slides.forEach(function (s, i) {
        s.classList.toggle('wsh-slides__slide--active', i === index);
      });
    }

    thumbs.forEach(function (t, i) {
      t.classList.toggle('wsh-slides__thumb--active', i === index);
    });

    dots.forEach(function (d, i) {
      d.classList.toggle('wsh-slides__dot--active', i === index);
    });
  }

  /* Thumbnail clicks */
  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      goToSlide(i);
    });
  });

  /* Dot clicks */
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      goToSlide(i);
    });
  });

  /* Arrows */
  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goToSlide(currentIndex - 1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goToSlide(currentIndex + 1);
    });
  }

  /* Keyboard navigation */
  main.setAttribute('tabindex', '0');
  main.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      goToSlide(currentIndex - 1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      goToSlide(currentIndex + 1);
    }
  });

  /* Mobile: sync dots with scroll position */
  var scrollTimer;
  main.addEventListener('scroll', function () {
    if (!isMobile()) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      var scrollLeft = main.scrollLeft;
      var slideWidth = main.offsetWidth;
      var newIndex = Math.round(scrollLeft / slideWidth);
      if (newIndex !== currentIndex && newIndex >= 0 && newIndex < slides.length) {
        currentIndex = newIndex;
        dots.forEach(function (d, i) {
          d.classList.toggle('wsh-slides__dot--active', i === currentIndex);
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('wsh-slides__thumb--active', i === currentIndex);
        });
      }
    }, 50);
  }, { passive: true });

  /* Initialize first slide */
  goToSlide(0);
})();
